<!--
 * @Description: 项目申报组件
 * @Author: xiawenlong
 * @Date: 2026-04-02
-->
<template>
  <div class="project-declaration">
    <div class="title">
      <span>项目申报</span>
    </div>
    <div class="content">
      <div class="item">
        <div class="badge">
          <div class="particles">
            <span v-for="n in 6" :key="n" class="particle" :class="'p' + n"></span>
          </div>
          <img :src="provincialBadgeImage" alt="省级项目" width="100%" height="100%" />
        </div>
        <div class="info">
          <div class="value">
            <span class="number">{{ provincialProjectCount }}</span>
            <span class="unit">项</span>
          </div>
          <div class="label">省级项目数量</div>
        </div>
      </div>
      <div class="item">
        <div class="badge">
          <div class="particles">
            <span v-for="n in 6" :key="n" class="particle" :class="'p' + n"></span>
          </div>
          <img :src="nationalBadgeImage" alt="国家级项目" width="100%" height="100%" />
        </div>
        <div class="info">
          <div class="value">
            <span class="number">{{ nationalProjectCount }}</span>
            <span class="unit">项</span>
          </div>
          <div class="label">国家级项目数量</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectDeclaration',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    provincialBadgeImage() {
      return require('@/img/agriculture/badge1.png')
    },
    nationalBadgeImage() {
      return require('@/img/agriculture/badge2.png')
    },
    provincialProjectCount() {
      return this.data.provincialProjectCount || 0
    },
    nationalProjectCount() {
      return this.data.nationalProjectCount || 0
    },
  },
}
</script>

<style lang="scss" scoped>
.project-declaration {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .title {
    position: relative;
    width: 100%;
    height: 50px;
    border-radius: 7px 7px 0px 0px;
    font-weight: bold;
    font-size: 30px;
    color: #fefefe;
    line-height: 50px;
    padding-left: 47px;

    span {
      position: relative;
      z-index: 9;
    }

    &::after {
      z-index: 8;
      content: '';
      position: absolute;
      left: 25px;
      bottom: 5px;
      width: 366px;
      height: 23px;
      background: url('~@/img/agriculture/title_line.png') 100% 100%;
    }
  }

  .content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 134px;
    padding-top: 49px;

    .item {
      display: flex;

      .badge {
        width: 156px;
        height: 121px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-right: 28px;
        position: relative;

        .particles {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          pointer-events: none;

          .particle {
            position: absolute;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: rgba(91, 192, 248, 0.8);
            box-shadow: 0 0 6px rgba(91, 192, 248, 0.6);

            &.p1 {
              top: 0;
              left: 50%;
              animation: particle-float1 2.5s ease-in-out infinite;
            }
            &.p2 {
              top: 50%;
              right: 0;
              animation: particle-float2 3s ease-in-out infinite 0.3s;
            }
            &.p3 {
              bottom: 0;
              left: 50%;
              animation: particle-float3 2.8s ease-in-out infinite 0.6s;
            }
            &.p4 {
              top: 50%;
              left: 0;
              animation: particle-float4 3.2s ease-in-out infinite 0.9s;
            }
            &.p5 {
              top: 15%;
              left: 15%;
              animation: particle-float5 2.6s ease-in-out infinite 1.2s;
            }
            &.p6 {
              bottom: 15%;
              right: 15%;
              animation: particle-float6 3.4s ease-in-out infinite 1.5s;
            }
          }
        }

        img {
          position: relative;
          z-index: 1;
        }
      }

      .info {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding-top: 33px;

        .label {
          width: 164px;
          font-size: 21px;
          color: #ffffff;
          line-height: 21px;
          padding-left: 30px;
          white-space: nowrap;
          background: url('~@/img/agriculture/square_title_bg.png') 100% 100% no-repeat;
          padding-bottom: 10px;
        }

        .value {
          display: flex;
          align-items: baseline;
          gap: 8px;

          .number {
            font-size: 36px;
            font-weight: bold;
            color: #00f0ff;
            line-height: 1;
            font-family: 'DIN Alternate', 'Arial', sans-serif;
            text-shadow: 0 2px 8px rgba(8, 141, 218, 0.4);
            background: linear-gradient(180deg, #ffffff 0%, #ffffff 40%, #5bc0f8 80%, #088dda 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .unit {
            font-size: 21px;
            color: #ffffff;
            line-height: 36px;
          }
        }
      }
    }
  }
}

@keyframes particle-float1 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }
  50% {
    transform: translate(-8px, -12px) scale(1.3);
    opacity: 1;
  }
}

@keyframes particle-float2 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }
  50% {
    transform: translate(12px, -8px) scale(1.3);
    opacity: 1;
  }
}

@keyframes particle-float3 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }
  50% {
    transform: translate(8px, 12px) scale(1.3);
    opacity: 1;
  }
}

@keyframes particle-float4 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }
  50% {
    transform: translate(-12px, 8px) scale(1.3);
    opacity: 1;
  }
}

@keyframes particle-float5 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate(-10px, -6px) scale(1.5);
    opacity: 1;
  }
}

@keyframes particle-float6 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate(10px, 6px) scale(1.5);
    opacity: 1;
  }
}
</style>
